import { createApp } from 'vue'
import App from './App.vue'
import {
  Tabs,
  TabPane,
  Alert, 
  Button, 
  Pagination, 
  Table, 
  Tag, 
  Modal, 
  Form, 
  Input, 
  Select, 
  Checkbox, 
  Layout, 
  Row, 
  Col, 
  Tooltip, 
  Card, 
  Space, 
  Upload, 
  Spin, 
  Menu, 
  message, 
  Popconfirm,
  InputNumber,
  Progress,
  Switch,
  Avatar,
  Dropdown,
  Radio
} from 'ant-design-vue'
import router from './router/router'
import { pinia } from './store'
import 'ant-design-vue/dist/antd.css'


const app = createApp(App)
app.use(Tabs)
app.use(TabPane)
app.use(Button)
app.use(Alert)
app.use(Modal)
app.use(Form)
app.use(Table)
app.use(Input)
app.use(Tag)
app.use(Select)
app.use(Pagination)
app.use(Checkbox)
app.use(Layout)
app.use(Row)
app.use(Col)
app.use(Tooltip)
app.use(Card)
app.use(Space)
app.use(Upload)
app.use(Spin)
app.use(Menu)
app.use(Popconfirm)
app.use(InputNumber)
app.use(Progress)
app.use(Switch)
app.use(Avatar)
app.use(Dropdown)
app.use(Radio)
app.use(message)
app.use(pinia)
app.use(router);
app.mount('#app')
